import { EmailDataRequest } from "../types/empresa";
import { apiSlice } from "./baseQuery";

export const emailClientApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        sendEmail: build.mutation<void, EmailDataRequest>({
            query: (emailRequest: EmailDataRequest) => ({
                url: "/api/empresas/email",
                method: "POST",
                body: {...emailRequest},
            }),
        }),
    })
});

export const {
    useSendEmailMutation,
} = emailClientApi;